import { pathOr } from "ramda";
export const moduleManagers = (state, moduleId) =>
  pathOr([], [moduleId, "managers"], state.modules.managers);
export const moduleManagerRoles = (state, moduleId) =>
  pathOr([], [moduleId, "roles"], state.modules.managers);
